/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import Layout from './Layout';
import { HeroMm } from './HeroSections';
import { MmOverview } from './PageSections';
import Clients from './Clients';
import { ServicesMm } from './Services';
import Testimonials from './Testimonials';
import Contact from './Contact';

interface PageProps { user: string | null; }

const MmPage = ({ user }: PageProps) => (
  <Layout user={user}>
    <HeroMm />
    <MmOverview />
    <Clients />
    <ServicesMm />
    <Testimonials />
    <Contact />
  </Layout>
);

export default MmPage;
